module.exports = __webpack_public_path__ + "static/PP9-427770c868aea8f9923ff0a3e6c26e2f.jpg";